export type GetStreakResponseType = {
  streak_goal: number;
  daily_score: {
    date: string;
    score: number;
  }[];
};

export function parseGetStreakResponse(res: GetStreakResponseType) {
  return {
    streakGoal: res.streak_goal,
    data: res.daily_score,
  };
}
